/* eslint-disable import/prefer-default-export */

import config from '../config';

export const USER_ROLES = {
  SUPERADMIN: 'rol_super_administrador',
  SEDE: 'rol_sede',
  ORIENTACION: 'rol_orientacion',
  SECRETARIA: 'rol_secretaria',
  DELEGACION: 'rol_delegacion',
};

export const MATRICULAS_SOLO_LECTURA = ['vfeneux@cedetecgroup.com'];

// Pantalla pública de conexión del MCP de alumnos (OAuth del MCP en apis-node). Se pinta
// fuera de la puerta de sesión y de FullLayout, y sin las redirecciones globales
// a `/` de authContext. Debe coincidir con `location = /mcp-login` de nginx.conf.
export const MCP_LOGIN_PATH = '/mcp-login';

// Denylist del login: emails que el front NO deja pasar aunque estén en la
// whitelist (o aunque la whitelist esté vacía = "todos permitidos"). Se lee de
// `REACT_APP_BLOCKED_EMAILS` (CSV) para no hardcodear datos personales en el
// repo, igual que el backend con `BLOCKED_EMAILS`. OJO: es solo cosmético —
// el bloqueo real es server-side (verifyEmail). Vacío = no bloquea en el front.
export const EMAILS_BLOQUEADOS = (config.REACT_APP_BLOCKED_EMAILS || '')
  .split(',')
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

export const EMAIL_GROUPS = {
  PERSONAL: 'EMAIL_GROUP_PERSONAL',
  CENTRO: 'EMAIL_GROUP_CENTRO',
  TUTOR1: 'EMAIL_GROUP_TUTOR1',
  TUTOR2: 'EMAIL_GROUP_TUTOR2',
};
